(function () {
  if (window.AnanasLightbox) return;

  var triggerSelector = '[data-ananas-lightbox-trigger]';
  var state = {
    items: [],
    index: 0,
    pointerStartX: 0,
    pointerStartY: 0,
    pointerMoved: false,
    pointerTracking: false,
    pointerTrigger: null,
    suppressClick: false,
  };

  function createButton(label, html, action) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ananas-lightbox__button';
    button.setAttribute('aria-label', label);
    button.setAttribute('data-ananas-lightbox-' + action, '');
    button.innerHTML = html;
    return button;
  }

  function ensureLightbox() {
    var existing = document.querySelector('[data-ananas-lightbox]');
    if (existing) return existing;

    var lightbox = document.createElement('div');
    lightbox.className = 'ananas-lightbox';
    lightbox.setAttribute('data-ananas-lightbox', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Görsel');
    lightbox.setAttribute('aria-hidden', 'true');

    var image = document.createElement('img');
    image.className = 'ananas-lightbox__image';
    image.alt = '';
    image.width = 1600;
    image.height = 1200;
    image.setAttribute('data-ananas-lightbox-image', '');

    var controls = document.createElement('div');
    controls.className = 'ananas-lightbox__controls';

    var previous = createButton(
      'Önceki görsel',
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="m15 18-6-6 6-6"/></svg>',
      'previous'
    );
    var close = createButton(
      'Kapat',
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="M18 6 6 18M6 6l12 12"/></svg>',
      'close'
    );
    var next = createButton(
      'Sonraki görsel',
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"><path d="m9 18 6-6-6-6"/></svg>',
      'next'
    );

    controls.append(previous, close, next);
    lightbox.append(image, controls);
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function getImageData(trigger) {
    var image = trigger.querySelector('img');
    var src = trigger.getAttribute('data-ananas-lightbox-src')
      || trigger.getAttribute('data-media-large-src')
      || trigger.getAttribute('data-article-slider-large-src')
      || (image ? image.currentSrc || image.src : '');
    var alt = trigger.getAttribute('data-ananas-lightbox-alt')
      || trigger.getAttribute('data-media-alt')
      || trigger.getAttribute('data-article-slider-alt')
      || (image ? image.alt : '');

    if (!src) return null;
    return { src: src, alt: alt || '' };
  }

  function getGroup(trigger) {
    return trigger.closest('[data-ananas-lightbox-group]')
      || trigger.closest('[data-product-gallery]')
      || trigger.closest('[data-ananas-article-slider]')
      || document;
  }

  function getGroupItems(trigger) {
    var group = getGroup(trigger);
    return Array.prototype.slice.call(group.querySelectorAll(triggerSelector))
      .map(function (item) {
        var data = getImageData(item);
        if (!data) return null;
        return {
          element: item,
          src: data.src,
          alt: data.alt,
        };
      })
      .filter(Boolean);
  }

  function isInactiveSlide(trigger) {
    if (trigger.matches('[data-article-slider-slide]')) {
      return !trigger.classList.contains('is-active');
    }

    if (trigger.matches('[data-product-media]')) {
      return !trigger.hasAttribute('data-active');
    }

    return false;
  }

  function render() {
    var lightbox = ensureLightbox();
    var image = lightbox.querySelector('[data-ananas-lightbox-image]');
    var previous = lightbox.querySelector('[data-ananas-lightbox-previous]');
    var next = lightbox.querySelector('[data-ananas-lightbox-next]');
    var item = state.items[state.index];

    if (!image || !item) return;

    image.src = item.src;
    image.alt = item.alt;

    var hasMultiple = state.items.length > 1;
    if (previous) previous.disabled = !hasMultiple;
    if (next) next.disabled = !hasMultiple;
  }

  function open(trigger) {
    var directData = trigger && trigger.src ? { src: trigger.src, alt: trigger.alt || '' } : null;
    state.items = trigger && trigger.element
      ? trigger.items || [trigger]
      : getGroupItems(trigger);

    if (directData) {
      state.items = [{ src: directData.src, alt: directData.alt }];
    }

    if (!state.items.length) return;

    if (trigger && trigger.element) {
      state.index = Math.max(0, state.items.findIndex(function (item) {
        return item.element === trigger.element;
      }));
    } else {
      state.index = Math.max(0, state.items.findIndex(function (item) {
        return item.element === trigger;
      }));
    }

    var lightbox = ensureLightbox();
    render();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ananas-lightbox-open');
    lightbox.querySelector('[data-ananas-lightbox-close]')?.focus();
  }

  function close() {
    var lightbox = ensureLightbox();
    var image = lightbox.querySelector('[data-ananas-lightbox-image]');

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ananas-lightbox-open');
    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
  }

  function move(direction) {
    if (state.items.length < 2) return;
    state.index = (state.index + direction + state.items.length) % state.items.length;
    render();
  }

  window.AnanasLightbox = {
    open: open,
    close: close,
    next: function () {
      move(1);
    },
    previous: function () {
      move(-1);
    },
  };

  document.addEventListener('pointerdown', function (event) {
    var trigger = event.target.closest?.(triggerSelector);
    state.pointerTracking = Boolean(trigger);
    state.pointerTrigger = trigger || null;
    state.pointerMoved = false;
    if (!trigger) return;

    state.pointerStartX = event.clientX;
    state.pointerStartY = event.clientY;
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!state.pointerTracking) return;

    if (Math.abs(event.clientX - state.pointerStartX) > 8 || Math.abs(event.clientY - state.pointerStartY) > 8) {
      state.pointerMoved = true;
    }
  }, true);

  document.addEventListener('pointerup', function (event) {
    if (!state.pointerTracking) return;

    var trigger = state.pointerTrigger;
    state.pointerTracking = false;
    state.pointerTrigger = null;

    if (state.pointerMoved || !trigger) {
      state.suppressClick = state.pointerMoved;
      window.setTimeout(function () {
        state.suppressClick = false;
      }, 160);
      return;
    }

    if (isInactiveSlide(trigger)) return;

    event.preventDefault();
    event.stopPropagation();
    open(trigger);

    state.suppressClick = true;
    window.setTimeout(function () {
      state.suppressClick = false;
    }, 160);
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest?.(triggerSelector);
    if (!trigger || state.suppressClick || isInactiveSlide(trigger)) return;

    event.preventDefault();
    event.stopPropagation();
    open(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest?.('[data-ananas-lightbox-close]')) {
      close();
      return;
    }

    if (event.target.closest?.('[data-ananas-lightbox-previous]')) {
      move(-1);
      return;
    }

    if (event.target.closest?.('[data-ananas-lightbox-next]')) {
      move(1);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
  });
})();
